import $x from '../utils/$x';

const BASE_PATH = '/capabilityConfig/manage';

function post(path, requestData = {}) {
  return $x.post(`${BASE_PATH}${path}`, { requestData });
}

/** 查询某个能力配置作用域的草稿、当前发布版本与历史版本。 */
export function queryCapabilityConfigDetail(requestData) {
  return post('/detail', requestData);
}

/** 创建或按修订号更新能力配置草稿。 */
export function saveCapabilityConfigDraft(requestData) {
  return post('/draft/save', requestData);
}

/** 将当前草稿发布为不可变 Release。 */
export function publishCapabilityConfigDraft(requestData) {
  return post('/release/publish', requestData);
}

/** 生成动作能力画像或证据配方候选；服务端不会自动保存草稿。 */
export function generateCapabilityConfigCandidate(requestData) {
  return post('/candidate/generate', requestData);
}
